import { FC } from 'react';
import { IconProps } from '@base/icon/interface';
import { SVG } from '@base/icon/SVG';

export const IconMenu: FC<IconProps> = props => (
    <SVG
        {...props}
        path="M85.333333 256a42.666667 42.666667 0 0 1 42.666667-42.666667h768a42.666667 42.666667 0 1 1 0 85.333334H128a42.666667 42.666667 0 0 1-42.666667-42.666667z m0 256a42.666667 42.666667 0 0 1 42.666667-42.666667h768a42.666667 42.666667 0 1 1 0 85.333334H128a42.666667 42.666667 0 0 1-42.666667-42.666667z m0 256a42.666667 42.666667 0 0 1 42.666667-42.666667h768a42.666667 42.666667 0 1 1 0 85.333334H128a42.666667 42.666667 0 0 1-42.666667-42.666667z"
    />
);